<template>
	<div class="billboard-inner text-center padding-top-40" :class="componentClass">
		<i :class="decode('plan', type)" aria-hidden="true"></i>
		<h3>{{ $t('Sentence.PricingTablePlan' + type + 'Title') }}</h3>
		<strong class="margin-bottom-50" v-html="planPrice"></strong>
		<ul class="list-none billboard-list">
			<li v-html="$t('Sentence.PricingTablePlan' + type + 'Row1')"></li>
			<li v-html="$t('Sentence.PricingTablePlan' + type + 'Row2')"></li>
		</ul>
	</div>
</template>

<script>
import Config from '@/config'
import Helpers from '@/mixins/Helpers'
import IconInfo from '@/mixins/IconInfo'

export default {
	name: 'PlanBox',
	mixins: [Helpers, IconInfo],
	props: {
		componentClass: {
			type: String,
			default: '',
		},
		type: {
			type: Number,
			required: true,
			validator: (value) => {
				return [Config.REQUEST_PLAN_FREE, Config.REQUEST_PLAN_BASIC, Config.REQUEST_PLAN_PREMIUM].indexOf(value) !== -1
			},
		},
	},
	computed: {
		planPrice() {
			if (this.type == Config.REQUEST_PLAN_FREE) {
				return '<span>Gratis</span>'
			} else if (this.type == Config.REQUEST_PLAN_BASIC) {
				return '<span>€</span>2,99'
			} else if (this.type == Config.REQUEST_PLAN_PREMIUM) {
				return '<span>€</span>9,99'
			} else {
				return '-'
			}
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/partials/PlanBox.vue